import { Breakpoint, Color, FontWeight, hexToRgba, Markdown, Typography } from '@elearning-platform/ui';
import { styled } from 'styled-components';

import { ImageContainerProps } from './contactSlide.types';

export const Wrapper = styled.div`
  width: 100%;
  min-height: 676px;
  display: flex;
  flex-direction: column;
  background-color: ${Color.Gray100};
  padding: 40px 16px;
  gap: 40px;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
    padding: 0;
    gap: 0;
  }
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: space-between;
  padding: 0;

  @media ${Breakpoint.SmallDesktop} {
    padding: 80px 40px;
  }

  @media ${Breakpoint.Desktop} {
    padding: 80px;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  margin-top: 80px;
`;

export const StyledMarkdown = styled(Markdown)`
  em {
    color: ${Color.Brand100};
    font-style: normal;
    font-weight: ${FontWeight.Bold};
  }
`;

export const ImageContainer = styled.div<ImageContainerProps>`
  display: flex;
  align-items: center;
  justify-content: center;
  background-image: ${({ $image }: ImageContainerProps): string => `url(${$image})`};
  background-size: cover;
  background-repeat: no-repeat;
  padding: 0;

  @media ${Breakpoint.SmallDesktop} {
    ${({ $withImageText }: ImageContainerProps): string => $withImageText ? 'max-width: 300px' : 'min-width: 300px'};
  }


  @media ${Breakpoint.Desktop} {
    ${({ $withImageText }: ImageContainerProps): string => $withImageText ? 'max-width: 375px' : 'min-width: 375px'};
    padding: 0 46px;
  }
`;

export const ContactsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ContactInfoboxWrapper = styled.div`
  padding: 20px;
  background-color: ${Color.White};
`;

export const RightTextContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 40px 16px;
  background: ${hexToRgba(Color.Black100, 0.8)};

  @media ${Breakpoint.SmallDesktop} {
    padding: 40px;
  }
`;

export const StyledTypography = styled(Typography)`
  color: ${Color.White};
`;
